export default __webpack_public_path__ + "static/media/sunsculpted6.caef3ebe.jpg";